type HalloweenHeaderIntensity = "full" | "subtle";

/** Halloween-Header-Dekoration (24.–31. Oktober / Dev-Simulation) – rein visuell. */
export function HalloweenHeaderDecor({
  intensity = "full",
}: {
  intensity?: HalloweenHeaderIntensity;
}) {
  const full = intensity === "full";
  return (
    <div
      className="eh-hw-header-decor pointer-events-none absolute inset-0 z-[1] overflow-hidden"
      aria-hidden="true"
    >
      {full ? <div className="eh-hw-header-decor__glow" /> : null}
      {full ? <div className="eh-hw-header-decor__garland" /> : null}
      <div className="eh-hw-header-decor__web eh-hw-header-decor__web--left" />
      <div className="eh-hw-header-decor__web eh-hw-header-decor__web--right" />
      <div className="eh-hw-header-decor__spider" />
      <div className="eh-hw-header-decor__pumpkin eh-hw-header-decor__pumpkin--left" />
      <div className="eh-hw-header-decor__pumpkin eh-hw-header-decor__pumpkin--right" />
    </div>
  );
}

/** Flackernde Laternen über der Navigation. */
export function HalloweenNavLights() {
  return (
    <div
      className="eh-hw-nav-lights pointer-events-none absolute inset-x-0 top-0 z-[1] h-3 -translate-y-1/2"
      aria-hidden="true"
    >
      {Array.from({ length: 24 }, (_, i) => (
        <span
          key={i}
          className="eh-hw-nav-lights__lantern"
          style={{ animationDelay: `${(i % 5) * 0.45}s` }}
        />
      ))}
    </div>
  );
}
